import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/engagement/tiffin";

export const Route = createFileRoute("/admin/_engagement/tiffin")({
  component: Page,
});
